import { useEffect, useState } from 'react'

type Props = {
  onLogin: (token: string) => void
}

/**
 * OAuth コールバックコンポーネント
 *
 * Google認証後のリダイレクト先。
 * URLからcode/stateを抽出し、バックエンドでJWTと交換してログイン。
 */
export function OAuthCallback({ onLogin }: Props) {
  const [error, setError] = useState('')

  useEffect(() => {
    const handleCallback = async () => {
      // URLからcode/stateを抽出
      const params = new URLSearchParams(window.location.search)
      const code = params.get('code')
      const state = params.get('state')

      if (!code || !state) {
        setError('Missing authorization code or state')
        return
      }

      try {
        // バックエンドでcode→JWT交換
        const res = await fetch('/api/auth/callback', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code, state }),
        })

        if (!res.ok) {
          const errorData = await res.json()
          throw new Error(errorData.error || 'Authentication failed')
        }

        const data = await res.json()

        // JWTを保存してログイン
        onLogin(data.token)

        // トップページにリダイレクト(認証済みなので自動的に/homeへ)
        window.location.href = '/'
      } catch (err) {
        console.error('OAuth callback error:', err)
        setError(
          err instanceof Error ? err.message : 'Authentication failed. Please try again.'
        )
      }
    }

    handleCallback()
  }, [onLogin])

  if (error) {
    return (
      <div className="login-container">
        <div className="login-form">
          <h2>Authentication Error</h2>
          <p className="error-message">{error}</p>
          <button
            onClick={() => (window.location.href = '/')}
            className="login-button"
          >
            Back to Login
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Completing sign in...</h2>
        <p className="login-subtitle">Please wait</p>
      </div>
    </div>
  )
}
